import { useEffect, useState } from 'react';

type useCompleteListPaginationProps = {
  list: any[];
  maxPerPage: number;
};

export const useCompleteListPagination = ({ list, maxPerPage }: useCompleteListPaginationProps) => {
  const [paginatedList, setPaginatedList] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(false);
  const [isLoading, setIsLoading] = useState(false); // Add isLoading state

  useEffect(() => {
    const startIndex = (page - 1) * maxPerPage;
    const endIndex = startIndex + maxPerPage;
    const newPaginatedList = list.slice(0, endIndex);
    setPaginatedList(newPaginatedList);
    setHasMore(newPaginatedList.length > 0 && newPaginatedList.length < list.length);
    setIsLoading(false);
  }, [list, page, maxPerPage]);

  const loadMore = () => {
    setIsLoading(true);
    setPage((prevPage) => prevPage + 1);
  };

  return { paginatedList, loadMore, hasMore, isLoading };
};
